import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { useContext } from 'react';
import { LinesDataProvider } from '../../../../LinesDataProvider';
import SelectInput from 'common/components/selectInput/SelectInput';

interface Props {
    parameter: BudgetLineParameterDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterSupplier({ parameter, disabled, onChange }: Props): JSX.Element | null {
    const { suppliers } = useContext(LinesDataProvider);

    const options = suppliers.map(s => ({
        value: s.id,
        label: s.name
    }));

    return (
        <SelectInput
            options={options}
            value={parameter.supplierId ?? null}
            onChange={(newValue) => onChange({ supplierId: newValue ?? null }, false)}
            disabled={disabled}
        />
    );
}

export default ParameterSupplier;
